import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { InstantAnswerContext, InstantAnswerScenario } from "../../types";

import { getVerifyAccountCTA } from "./shared";

export const ProvideRequestedInfoIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getVerifyAccountCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getVerifyAccountCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => VERIFY_YOUR_ACCOUNT(strictLocalize),
    getDescription: () => [
      IF_YOU_HAVE_NOT_SUBMITTED(strictLocalize),
      IF_YOU_HAVE_ALREADY_SUBMITTED(strictLocalize),
    ],
  };
};

const VERIFY_YOUR_ACCOUNT = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Providing information to verify your account",
    description: {
      text: "Title for the answer of Provide requested information issue",
    },
  });

const IF_YOU_HAVE_NOT_SUBMITTED = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "If you haven’t submitted the account verification form, please provide all required information there.",
  });

const IF_YOU_HAVE_ALREADY_SUBMITTED = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If you’ve already submitted the form, you’ll receive an email as soon as we review your info. We typically respond within 1 business day.",
  });
